import { GuardInput, ForManagingTeams } from 'core'
import { createState } from 'shared'

const { state: teamMemberCountState, updateState: updateTeamMemberCount } =
	createState(1)

const { state: teamName, updateState: updateTeamName } = createState<{
	value: string
	error?: string
}>({
	value: '',
	error: ''
})

// Actions to update team members
export const setTeamName = (name: string) => {
	if (name === '') {
		updateTeamName(() => ({ value: '', error: '' }))
		return
	}

	const teamNameError = GuardInput.check(
		ForManagingTeams.CreateTeam.partial(),
		{
			name
		}
	)

	if (teamNameError) {
		updateTeamName(() => ({
			value: name,
			error: teamNameError?.inputErrors?.name
		}))
	} else {
		updateTeamName(() => ({ value: name, error: '' }))
	}
}

export { teamMemberCountState, updateTeamMemberCount, teamName, updateTeamName }
